<template lang="pug">
  lei-modal.challenge-modal(@close="toggleModal(false)" :title="modalTitle" size="md" :close-with-overlay="false")
    challenge-compare-block(
      :value="newAddress.country"
      :jsonPath="addressWithPath.country.jsonPath"
      :oldValue="oldCountry"
      @change="value => setNewValue('country', value)"
      label="Propose Country"
      labelForOld="Old Country")

    challenge-compare-block(
      :value="newAddress.city"
      :jsonPath="addressWithPath.city.jsonPath"
      :oldValue="challengeAddress.city"
      @change="value => setNewValue('city', value)"
      label="Propose City"
      labelForOld="Old City")

    challenge-compare-block(
      :value="newAddress.addressNumber"
      :jsonPath="addressWithPath.addressNumber.jsonPath"
      :oldValue="challengeAddress.addressNumber"
      @change="value => setNewValue('addressNumber', value)"
      label="Propose Address Number"
      labelForOld="Old Address Number")

    challenge-compare-block(
      :value="newAddress.addressNumberWithinBuilding"
      :jsonPath="addressWithPath.addressNumberWithinBuilding.jsonPath"
      :oldValue="challengeAddress.addressNumberWithinBuilding"
      @change="value => setNewValue('addressNumberWithinBuilding', value)"
      label="Propose Address Number Within Building"
      labelForOld="Old Address Number Within Building")

    challenge-compare-block(
      :value="newAddress.mailRouting"
      :jsonPath="addressWithPath.mailRouting.jsonPath"
      :oldValue="challengeAddress.mailRouting"
      @change="value => setNewValue('mailRouting', value)"
      label="Propose Mail Routing"
      labelForOld="Old Mail Routing")

    challenge-compare-block(
      :value="newAddress.region"
      :jsonPath="addressWithPath.region.jsonPath"
      :oldValue="oldRegion"
      @change="value => setNewValue('region', value)"
      label="Propose Region"
      labelForOld="Old Region")

    challenge-compare-block(
      :value="newAddress.postalCode"
      :jsonPath="addressWithPath.postalCode.jsonPath"
      :oldValue="challengeAddress.postalCode"
      @change="value => setNewValue('postalCode', value)"
      label="Propose Postal Code"
      labelForOld="Old Postal Code")

    challenge-address-lines(
      :addressLines="addressWithPath.addressLines"
      :oldAddressLines="challengeAddress.addressLines"
      @change="setAddressLine"
      @add="addAddressLine"
      @remove="removeAddressLine")

    comment-input(@input="comment=$event")

    div(slot="footer")
      lei-btn(type="cyprus" fill @click="save" :disabled="disabled") Save
</template>
<script>
import { mapState, mapMutations, mapActions, } from 'vuex'
import {
  TOGGLE_CHALLENGE_ADDRESS_MODAL,
  SAVE_FIELD,
} from '../../store/modules/record/modules/challenge/mutations-types'
import { getCountryNameByCode, } from '../../utils/countries'
import { addPath, compare, getFields, } from '../../utils/address'
import { getFieldIdByPath, } from '../../utils/challenge'
import InputCreator from '../lei-components/inputs/InputCreator'
import LeiModal from '../lei-components/LeiModal'
import LeiBtn from '../lei-components/LeiBtn'
import LeiPopover from '../lei-components/LeiPopover'
import { EventBus, } from '../../event-bus'
import ChallengeCompareBlock from '@/components/challenge-components/ChallengeCompareBlock'
import ChallengeAddressLines from '@/components/challenge-components/ChallengeAddressLines'
import CommentInput from '@/components/lei-components/inputs/CommentInput'

export default {
  components: {
    CommentInput,
    ChallengeAddressLines,
    ChallengeCompareBlock,
    LeiPopover,
    LeiBtn,
    LeiModal,
    InputCreator,
  },
  data () {
    return {
      newAddress: {
        country: '',
        city: '',
        addressNumber: '',
        addressNumberWithinBuilding: '',
        mailRouting: '',
        region: '',
        postalCode: '',
        addressLines: [],
      },
      comment: {
        value: '',
        valid: true,
      },
      explanations: {
        postalCode: 'The postal code of this address as specified by the local postal service.',
        region: 'The code for a region (state, province, county, canton, etc) as used in postal addresses for the country of this address.',
        country: 'The mandatory country code of the legal entity\'s address.',
        city: 'The mandatory city line of the address.',
      },
    }
  },
  computed: {
    oldCountry () {
      return this.parseCountry(this.challengeAddress)
    },
    oldRegion () {
      return this.parseRegion(this.challengeAddress)
    },
    modalTitle () {
      return `Challenge: ${this.title}`
    },
    title () {
      return this.challengeAddress.title
    },
    rootPath () {
      return this.challengeAddress.rootPath
    },
    addressWithPath () {
      return addPath(this.newAddress, this.rootPath)
    },
    comparedAddress () {
      return compare(addPath(this.challengeAddress, this.rootPath), this.addressWithPath)
    },
    wasChanged () {
      return !!Object.keys(this.comparedAddress)
        .find((key) => {
          if (key === 'addressLines') {
            return this.comparedAddress[key].find((line) => line.newValue)
          } else {
            return this.comparedAddress[key] && this.comparedAddress[key].newValue
          }
        })
    },
    disabled () {
      return !this.wasChanged || !this.comment.valid
    },

    ...mapState('record/challenge', [ 'challengeAddress', ]),
    ...mapState('search', [ 'filters', ]),
  },
  created () {
    this.initNewAddress()
  },
  methods: {
    initNewAddress () {
      if (this.challengeAddress.addressLines) {
        this.newAddress.addressLines = Array(this.challengeAddress.addressLines.length).fill('')
      }
    },
    parseCountry (address) {
      return {
        code: address.country,
        name: getCountryNameByCode(address.country),
      }
    },
    parseRegion (address) {
      return { code: address.region || '', }
    },
    save () {
      EventBus.$emit('save-address', {
        newValue: this.comparedAddress,
        title: this.title,
        rootPath: this.rootPath,
      })
      getFields(this.comparedAddress).map(async (f) => {
        const { xpath, } = await this.getField(getFieldIdByPath(f.field))
        return this.saveField({
          ...f,
          field: xpath,
          jsonPath: f.field,
          comment: this.comment.value,
        })
      })
      this.toggleModal(false)
    },
    setNewValue (property, value) {
      this.newAddress[property] = value
    },
    setAddressLine ({ value, index, }) {
      this.$set(this.newAddress.addressLines, index, value)
    },
    removeAddressLine (index) {
      this.newAddress.addressLines.splice(index, 1)
    },
    addAddressLine () {
      this.newAddress.addressLines.push('')
    },

    ...mapMutations('record/challenge', {
      toggleModal: TOGGLE_CHALLENGE_ADDRESS_MODAL,
      saveField: SAVE_FIELD,
    }),
    ...mapActions('record/challenge', [ 'getField', ]),
  },
}
</script>
<style lang="stylus">
  @import "../../assets/styles/variables.styl"
  .challenge-modal
    .info
      cursor pointer
      margin-left 5px
      font-size 0.9rem

    .container.field
      .title
        font-size 1rem
        margin-bottom 10px
        font-weight 600
        color $default-color-bold

    .address-line-input
      display flex
      align-items center

    .address-line
      display flex
      flex-direction column
      margin-bottom 15px

      .label-tip-box
        margin 5px 0 10px

      .label
        font-size 0.9rem
        color $default-color
        display inline-flex
        align-items center

      .remove
        cursor pointer
        margin-left 15px
        font-size 125%

        &:hover
          color $danger-color

    .add-address-line
      font-size 90%
      color $default-color-middle
      text-decoration underline

      &:hover
        color $primary-color

    .description
      text-align justify
      color $default-color
      line-height 1.25

  @media (min-width: $laptop)
    .challenge-modal
      .container
        margin-bottom 25px

        &:last-child
          margin-bottom 0

</style>



// WEBPACK FOOTER //
// src/components/modals/ChallengeAddressModal.vue